import { Toggle } from '@teamsnap/teamsnap-ui';
import { sanitize } from 'dompurify';
import * as React from 'react';
import { PartnerOffering, RegistrationAddonState } from './types';

type Props = {
  availableAddons: PartnerOffering[];
  addonState: RegistrationAddonState[];
  hasRegistrationFee: boolean;
  onAddonUpdate: (state: RegistrationAddonState[]) => any;
};

const Addons: React.FC<Props> = ({ availableAddons, addonState, hasRegistrationFee, onAddonUpdate }) => {

  const toggleAddon = (partnerOfferingId: number) => {
    const updatedAddonState = [...addonState];
    const index = updatedAddonState.findIndex(e => e.partnerOfferingId === partnerOfferingId);
    if (index > -1) {
      updatedAddonState[index].enabled = !updatedAddonState[index].enabled;
      onAddonUpdate(updatedAddonState);
    }
  }

  React.useEffect(() => {
    availableAddons.forEach(a => {
      const state = getAddonState(a.id);
      if (a.requiresFees && state?.enabled && !hasRegistrationFee) {
        toggleAddon(a.id);
      }
    })
  }, [availableAddons, addonState, hasRegistrationFee]);

  const getAddonState = (id: number) => addonState?.find(e => e.partnerOfferingId === id);

  return (
    <>
      {availableAddons?.map((offering: PartnerOffering, index: number) => {
        const state = getAddonState(offering.id);
        return (
          <div className={`Pill u-spaceBottomLg u-padLg ${offering.requiresFees && !hasRegistrationFee ? 'sui-hidden' : ''}`} key={index}>
            <div className="sui-flex sui-items-center">
              <Toggle
                name={`offering-item-${index}-${offering.id}-toggle`}
                data-testid={`offering-item-${index}-${offering.id}-toggle`}
                inputProps={{
                  checked: state?.enabled ?? true,
                  onChange: () => {
                    toggleAddon(offering.id);
                  },
                }}
              />
              <span
                data-testid={`offering-item-${index}-${offering.id}-name`}
                className="sui-text-gray-10 sui-heading-sm sui-pl-1"
              >
                {offering.productName}
              </span>
            </div>
            <div dangerouslySetInnerHTML={{ __html: sanitize(offering.description) }} className="sui-p-2 [&_p]:sui-mb-2 [&_ul]:sui-pl-2"></div>
          </div>
        )
      })}
    </>
  );
}

export default Addons;